<template>
    <div :class="['input-wrapper', 'form-input-avatar-image-select', { 'input-wrapper-mb-2x': marginBottomDouble }]">
        <input :id="name" type="file" :name="name" style="display: none" accept="image/*" />
        <figure class="avatar-upload" @click="uploadAvatar">
            <span class="material-icons" v-if="!previewImg">photo_camera</span>
            <img v-else :src="previewImg" alt="Avatar" />
        </figure>
        <strong v-if="label" @click="uploadAvatar">{{ label }}</strong>
        <strong v-else @click="uploadAvatar">{{ __('Add your photo') }}</strong>

        <form-input-error v-if="hasError" :error="errors[0]" centered></form-input-error>
        <form-input-note v-else-if="note" :text="note" centered></form-input-note>
    </div>
</template>

<script>
    export default {
        props: {
            currentImage: {
                type: String,
                required: false,
                default: null
            },
            errors: {
                type: Array,
                required: false,
                default: null
            },
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                required: false,
                default: null
            },
            note: {
                type: String,
                required: false,
                default: null
            },
            marginBottomDouble: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        data() {
            return {
                previewImg: this.currentImage,
                inputValue: null,
                hasError: false
            }
        },

        watch: {
            errors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                    }
                }
            }
        },

        mounted() {
            const avatarSelect = document.getElementById(this.name)

            avatarSelect.addEventListener('change', (event) => {
                const reader = new FileReader()

                reader.addEventListener(
                    'load',
                    () => {
                        this.previewImg = reader.result
                    },
                    false
                )

                const image = avatarSelect.files[0]

                if (image) {
                    reader.readAsDataURL(image)

                    this.hasError = false
                }
            })
        },

        methods: {
            uploadAvatar() {
                document.getElementById(this.name).click()
            }
        }
    }
</script>
